import Login from 'wever-core/dist/components/security/login';
export default Login;